import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnLoader from "../toolbox/CgnLoader";
import ContentTop from "../root/ContentTop";
import CgnBadge from "../toolbox/CgnBadge";
import CgnAlert from "../toolbox/CgnAlert";
import CgnDatatable from "../toolbox/CgnDatatable";
import CgnMessage from "../toolbox/CgnMessage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import {
  localFilePath,
  URL,
  GetMonthFirstDate,
  GetMonthLastDate,
  GetMonthFirstDate2,
  GetMonthLastDate2,
  CustomerList,
} from "../../redux/actions/constants";
import CgnButtonDropdown from "../toolbox/CgnButtonDropdown";
import CgnButton from "../toolbox/CgnButton";
import CgnDatePicker from "../toolbox/CgnDatePicker";
import CgnReactSelect from "../toolbox/CgnReactSelect";

const isAuthorized = (authorizations, requiredPermissions = []) => {
  // Admin ise her zaman true döner
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  if (isAdmin) return true;

  if (!Array.isArray(authorizations) || authorizations.length === 0) {
    return false;
  }

  const userGuid = localStorage.getItem("membershipGuid")?.toLowerCase();
  if (!userGuid) return false;

  // Tek bir yetki string'i verildiyse diziye çevir
  const required = Array.isArray(requiredPermissions)
    ? requiredPermissions
    : [requiredPermissions];

  return authorizations.some((auth) => {
    if (auth?.memberGuid?.toLowerCase() !== userGuid) return false;

    // Tüm gerekli yetkilerin true olması şart
    return required.every((perm) => auth?.[perm] === true);
  });
};

class OfferList extends Component {
  state = {
    pageTitle: "Teklif Listele",
    pageAddLink: "teklif-ekle",
    pageUpdateLink: "teklif-guncelle",
    pageDetailLink: "teklif-detay",
    pageListLink: "teklif-listele",
    breadcrumb: [{ text: "Teklif", link: "#" }],
    isLoading: false,
    isDeleted: false,
    offerData: [],
    urlSplit: [],
    discountTotal: 0,
    totalPiece: 0,
    productItemCount: 0,
    discountTotalDolar: 0,
    totalPieceDolar: 0,
    productItemCountDolar: 0,
    discountTotalEuro: 0,
    totalPieceEuro: 0,
    productItemCountEuro: 0,
    statusAll: 0,
    status1: 0,
    status2: 0,
    status3: 0,
    status4: 0,
    status5: 0,
    status6: 0,
    status7: 0,
    status8: 0,
    status9: 0,
    status10: 0,
    status11: 0,
    status12: 0,
    status13: 0,
    status14: 0,
    status15: 0,
    guid: "",
    replaceLink: "",
    alertErrorMessage: "",
    detail: false,
    firstDate: "",
    firstDate2: "",
    lastDate: "",
    lastDate2: "",
    customerGuid: "00000000-0000-0000-0000-000000000000",
    customerArr: [],
    userGuid: "00000000-0000-0000-0000-000000000000",
    userArr: [],
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });

    let urlSplit = window.location.pathname.split("/");
    this.setState({
      urlSplit: urlSplit,
    });

    var firstDate = GetMonthFirstDate();
    var lastDate = GetMonthLastDate();
    var firstDate2 = GetMonthFirstDate2();
    var lastDate2 = GetMonthLastDate2();

    if (localStorage.getItem("firstDateOffer")) {
      firstDate = localStorage.getItem("firstDateOffer");
      firstDate2 = new Date(firstDate);
    }
    if (localStorage.getItem("lastDateOffer")) {
      lastDate = localStorage.getItem("lastDateOffer");
      lastDate2 = new Date(lastDate);
    }

    await this.setState({
      firstDate: firstDate,
      lastDate: lastDate,
      firstDate2: firstDate2,
      lastDate2: lastDate2,
    });

    //

    var self = this;

    await CustomerList().then(function (data) {
      self.setState({
        customerArr: data,
      });
    });

    if (localStorage.getItem("customerGuidOffer")) {
      this.setState({
        customerGuid: localStorage.getItem("customerGuidOffer"),
      });
    }

    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };

    await axios
      .get(URL + "/users/getlistuser2", config)
      .then((response) => {
        const currentGuid = localStorage.getItem("membershipGuid");

        var myArr = response.data.map((item) => ({
          value: item.guid,
          label: item.name,
        }));

        this.setState({
          userArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });

    if (localStorage.getItem("userGuidOffer")) {
      this.setState({
        userGuid: localStorage.getItem("userGuidOffer"),
      });
    }

    this.getList();
  }

  async handleFirstDateChange(firstDate) {
    if (firstDate) {
      await this.setState({
        firstDate:
          firstDate.getMonth() +
          1 +
          "." +
          firstDate.getDate() +
          "." +
          firstDate.getFullYear(),
        firstDate2: firstDate,
      });
    } else {
      var firstDate = GetMonthFirstDate();
      await this.setState({
        firstDate: firstDate,
        firstDate2: firstDate,
      });
    }
    localStorage.setItem("firstDateOffer", this.state.firstDate);
  }

  async handleLastDateChange(lastDate) {
    if (lastDate) {
      await this.setState({
        lastDate:
          lastDate.getMonth() +
          1 +
          "." +
          lastDate.getDate() +
          "." +
          lastDate.getFullYear(),
        lastDate2: lastDate,
      });
    } else {
      var lastDate = GetMonthLastDate();
      await this.setState({
        lastDate: lastDate,
        lastDate2: lastDate,
      });
    }
    localStorage.setItem("lastDateOffer", this.state.lastDate);
  }

  async handleCustomerSelectChange(option) {
    if (option) {
      await this.setState({
        customerGuid: option.value,
      });
    } else {
      await this.setState({
        customerGuid: "00000000-0000-0000-0000-000000000000",
      });
    }
    localStorage.setItem("customerGuidOffer", this.state.customerGuid);
  }

  async handleUserSelectChange(option) {
    if (option) {
      await this.setState({
        userGuid: option.value,
      });
    } else {
      await this.setState({
        userGuid: "00000000-0000-0000-0000-000000000000",
      });
    }
    localStorage.setItem("userGuidOffer", this.state.userGuid);
  }

  getList = async () => {
    this.setState({
      isLoading: true,
      alertErrorMessage: "",
    });

    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var URLParam = "";
    if (this.state.urlSplit[1] === "musteri-detay") {
      URLParam = "/offers/getlistforcustomer/" + this.state.urlSplit[2];
      this.setState({
        detail: true,
      });
    } else {
      var urlSplitX =
        this.state.urlSplit.length > 2 ? this.state.urlSplit[2] : 0;
      this.setState({
        urlSplitX: urlSplitX,
      });
      URLParam =
        "/offers/getlisttostatus/" +
        urlSplitX +
        "/" +
        this.state.firstDate +
        "/" +
        this.state.lastDate +
        "/" +
        this.state.customerGuid +
        "/" +
        this.state.userGuid;
    }

    await axios
      .get(URL + URLParam, config)
      .then((response) => {
        if (this.state.detail === false) {
          this.setState({
            offerData: response.data.offerDto,
            status1: response.data.status1,
            status2: response.data.status2,
            status3: response.data.status3,
            status4: response.data.status4,
            status5: response.data.status5,
            status6: response.data.status6,
            status7: response.data.status7,
            status8: response.data.status8,
            status9: response.data.status9,
            status10: response.data.status10,
            status11: response.data.status11,
            status12: response.data.status12,
            status13: response.data.status13,
            status14: response.data.status14,
            status15: response.data.status15,
            statusAll: response.data.statusAll,
          });
        } else {
          this.setState({
            offerData: response.data,
          });
        }
        var discountTotal = 0;
        var totalPiece = 0;
        var productItemCount = 0;
        var discountTotalDolar = 0;
        var totalPieceDolar = 0;
        var productItemCountDolar = 0;
        var discountTotalEuro = 0;
        var totalPieceEuro = 0;
        var productItemCountEuro = 0;
        this.state.offerData.forEach((element) => {
          if (element.currencyType === 1) {
            discountTotal += element.discountTotal;
            totalPiece += element.totalPiece;
            productItemCount += element.productItemCount;
          } else if (element.currencyType === 2) {
            discountTotalDolar += element.discountTotal;
            totalPieceDolar += element.totalPiece;
            productItemCountDolar += element.productItemCount;
          } else if (element.currencyType === 3) {
            discountTotalEuro += element.discountTotal;
            totalPieceEuro += element.totalPiece;
            productItemCountEuro += element.productItemCount;
          }
        });
        this.setState({
          discountTotal: discountTotal,
          totalPiece: totalPiece,
          productItemCount: productItemCount,
          discountTotalDolar: discountTotalDolar,
          totalPieceDolar: totalPieceDolar,
          productItemCountDolar: productItemCountDolar,
          discountTotalEuro: discountTotalEuro,
          totalPieceEuro: totalPieceEuro,
          productItemCountEuro: productItemCountEuro,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  handleDelete = (guid) => {
    confirmAlert({
      title: CgnMessage.deleteQuestionTitle,
      message: CgnMessage.deleteQuestionMessage,
      buttons: [
        {
          label: CgnMessage.deleteQuestionYes,
          onClick: () => this.deleteItem(guid),
        },
        {
          label: CgnMessage.deleteQuestionNo,
        },
      ],
    });
  };

  handleProductOutAlert = (guid) => {
    confirmAlert({
      title: CgnMessage.deleteQuestionTitle,
      message: CgnMessage.offerQuestionMessage,
      buttons: [
        {
          label: CgnMessage.deleteQuestionYes,
          onClick: () => this.handleOfferToProductOut(guid),
        },
        {
          label: CgnMessage.deleteQuestionNo,
        },
      ],
    });
  };

  async deleteItem(guid) {
    this.setState({
      isLoading: true,
    });
    //
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const URLParam = "/offers/delete";
    const obj = {
      guid,
    };
    axios
      .post(URL + URLParam, obj, config)
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  handleOfferToProductOut = async (guid) => {
    this.setState({
      isLoading: true,
    });
    //
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .post(URL + "/offers/offertoproductout/" + guid, "", config)
      .then((response) => {
        if (response.data) {
          window.open("/satis-guncelle/" + response.data, "_self");
        }
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  handleCopyOffer = async (guid) => {
    confirmAlert({
      title: CgnMessage.copyQuestionTitle,
      message: CgnMessage.copyQuestionMessage,
      buttons: [
        {
          label: CgnMessage.copyQuestionYes,
          onClick: () => this.copyItem(guid),
        },
        {
          label: CgnMessage.copyQuestionNo,
        },
      ],
    });
  };

  async copyItem(guid) {
    this.setState({
      isLoading: true,
    });
    //
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .post(URL + "/offers/newofferafterrevision/" + guid, "", config)
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  handlePdfPrint = async (guid) => {
    this.setState({
      isLoading: true,
    });
    //
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/offers/offerPrint/" + guid, config)
      .then((response) => {
        var myData = response.data;
        let replaceLink = myData.replace(localFilePath, "");
        if (replaceLink) {
          window.open(replaceLink, "_blank");
          this.setState({
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  handlePdfSendMail = async (guid) => {
    this.setState({
      isLoading: true,
    });
    //
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/offers/offerSendMail/" + guid, config)
      .then((response) => {
        confirmAlert({
          title: CgnMessage.sendMailTitle,
          message: response.data,
          buttons: [
            {
              label: CgnMessage.sendMailConfirm,
              className: "offerListSendMailAlert",
            },
          ],
        });
        this.setState({
          isLoading: false,
        });
      })
      .catch((error) => {
        confirmAlert({
          title: CgnMessage.sendMailTitle,
          message: error.response.data,
          buttons: [
            {
              label: CgnMessage.sendMailConfirm,
              className: "offerListSendMailAlert",
            },
          ],
        });
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  thStyle = {
    width: "120px",
  };

  thStyle2 = {
    width: "120px",
  };

  tdStyle = {
    width: "275px",
  };

  tdStyle2 = {
    width: "100px",
  };

  render() {
    return (
      <>
        {this.state.detail === false && (
          <ContentTop
            breadcrumb={this.state.breadcrumb}
            title={
              this.state.urlSplit[1] !== "musteri-detay"
                ? this.state.pageTitle
                : ""
            }
            addLink={"/" + this.state.pageAddLink}
            listLink={"/" + this.state.pageListLink}
          />
        )}
        <Row className="offerList" id="list">
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title={CgnMessage.alertErrorTitle}
                  text={this.state.alertErrorMessage}
                />
              )}
              {this.state.detail === false && (
                <div className="d-inline-block mb-3">
                  <a
                    href={`/${this.state.pageListLink}/${9}`}
                    style={{ backgroundColor: "#34cdbb" }}
                    className={
                      this.state.urlSplitX === "9"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Ön Görüşme: ${this.state.status9}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${8}`}
                    style={{ backgroundColor: "#cd34ad" }}
                    className={
                      this.state.urlSplitX === "8"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Fiyatlandırılacak: ${this.state.status8}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${7}`}
                    style={{ backgroundColor: "#6434CD" }}
                    className={
                      this.state.urlSplitX === "7"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Haber Verilecek: ${this.state.status7}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${1}`}
                    style={{ backgroundColor: "red" }}
                    className={
                      this.state.urlSplitX === "1"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Beklemede: ${this.state.status1}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${4}`}
                    style={{ backgroundColor: "#FF6E33" }}
                    className={
                      this.state.urlSplitX === "4"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Revize: ${this.state.status4}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${2}`}
                    style={{ backgroundColor: "#29B237" }}
                    className={
                      this.state.urlSplitX === "2"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Onaylandı: ${this.state.status2}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${11}`}
                    style={{ backgroundColor: "#0000FF", color: "#fff" }}
                    className={
                      this.state.urlSplitX === "11"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Fatura Bekleme: ${this.state.status11}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${5}`}
                    style={{ backgroundColor: "#0679AF" }}
                    className={
                      this.state.urlSplitX === "5"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Fatura Kesildi: ${this.state.status5}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${12}`}
                    style={{ backgroundColor: "#cd853f", color: "#fff" }}
                    className={
                      this.state.urlSplitX === "12"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Cari Bekleme: ${this.state.status12}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${13}`}
                    style={{ backgroundColor: "#a0522d" }}
                    className={
                      this.state.urlSplitX === "13"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Cari İşlendi: ${this.state.status13}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${6}`}
                    style={{ backgroundColor: "#7C4811" }}
                    className={
                      this.state.urlSplitX === "6"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Arşiv: ${this.state.status6}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${3}`}
                    style={{ backgroundColor: "#FFC433", color: "#333" }}
                    className={
                      this.state.urlSplitX === "3"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`İptal Edildi: ${this.state.status3}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${10}`}
                    style={{ backgroundColor: "#ffeb00", color: "#333" }}
                    className={
                      this.state.urlSplitX === "10"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Bilgilendirme: ${this.state.status10}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${14}`}
                    style={{ backgroundColor: "#8b8970", color: "#fff" }}
                    className={
                      this.state.urlSplitX === "14"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Garanti Kapsamında: ${this.state.status14}`}</a>
                  <a
                    href={`/${this.state.pageListLink}/${15}`}
                    style={{ backgroundColor: "#333333", color: "#fff" }}
                    className={
                      this.state.urlSplitX === "15"
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 mb-2"
                    }
                  >{`Sevk Edilecek: ${this.state.status15}`}</a>

                  <a
                    href={`/${this.state.pageListLink}`}
                    className={
                      this.state.urlSplitX === 0
                        ? "float-left statusTopButton mr-2 btn btn-primary mb-2"
                        : "float-left statusTopButton mr-2 bg-secondary mb-2"
                    }
                  >{`Tümü: ${this.state.statusAll}`}</a>
                </div>
              )}
              {this.state.detail === false && (
                <Row className="filterRow">
                  <Col className="pl-2 pr-2" md="2">
                    <CgnDatePicker
                      name="firstDate"
                      label="Baş. Tarihi"
                      selected={
                        this.state.firstDate2 &&
                        this.state.firstDate2.toString().indexOf("/") > 0
                          ? new Date(
                              this.state.firstDate2.split("/")[2] +
                                "-" +
                                this.state.firstDate2.split("/")[1] +
                                "-" +
                                this.state.firstDate2.split("/")[0]
                            )
                          : this.state.firstDate2
                      }
                      onChange={(firstDate2) =>
                        this.handleFirstDateChange(firstDate2)
                      }
                      maxDate={new Date(2100, 1, 1)}
                      minDate={new Date(1900, 1, 1)}
                      placeholder="GG/AA/YYYY"
                      autoComplete="off"
                    />
                  </Col>
                  <Col className="pl-2 pr-2" md="2">
                    <CgnDatePicker
                      name="lastDate"
                      label="Bit. Tarihi"
                      selected={
                        this.state.lastDate2 &&
                        this.state.lastDate2.toString().indexOf("/") > 0
                          ? new Date(
                              this.state.lastDate2.split("/")[2] +
                                "-" +
                                this.state.lastDate2.split("/")[1] +
                                "-" +
                                this.state.lastDate2.split("/")[0]
                            )
                          : this.state.lastDate2
                      }
                      onChange={(lastDate2) =>
                        this.handleLastDateChange(lastDate2)
                      }
                      maxDate={new Date(2100, 1, 1)}
                      minDate={new Date(1900, 1, 1)}
                      placeholder="GG/AA/YYYY"
                      autoComplete="off"
                    />
                  </Col>
                  <Col className="pl-2 pr-2" md="4">
                    <CgnReactSelect
                      name="customerGuid"
                      label="Müşteri"
                      placeholder="Müşteri seçiniz..."
                      selectValue={this.state.customerGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleCustomerSelectChange(option)
                      }
                      options={this.state.customerArr}
                    />
                  </Col>
                  <Col className="pl-2 pr-2" md="3">
                    <CgnReactSelect
                      name="userGuid"
                      label="Kullanıcı"
                      placeholder="Kullanıcı seçiniz..."
                      selectValue={this.state.userGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) => this.handleUserSelectChange(option)}
                      options={this.state.userArr}
                    />
                  </Col>
                  <Col className="pl-2 pr-0" md="1">
                    <CgnButton
                      type="button"
                      color="primary"
                      onClick={this.getList}
                      text="Listele"
                      className="listButton"
                    />
                  </Col>
                </Row>
              )}
              <CgnDatatable
                data={this.state.offerData}
                title={this.state.pageTitle}
                columns={[
                  {
                    name: "Teklif Bilgileri",
                    sortable: false,
                    cell: (row) => {
                      if (row.customerPhone !== null) {
                        var phone = row.customerPhone,
                          maskPhone = `${phone.substring(0, 1)}  ${
                            "(" + phone.substring(1, 4) + ")"
                          } ${phone.substring(4, 7)} ${phone.substring(
                            7,
                            9
                          )} ${phone.substring(9, 11)}`;
                      }
                      return (
                        <Table className="table table-responsive ">
                          <tbody>
                            <tr>
                              <th style={this.thStyle}>Tarih</th>
                              <td>{row.offerDate}</td>
                              <th style={this.thStyle2}>Teklif No</th>
                              <td>{row.offerNumber}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Müşteri</th>
                              <td>{row.customerName}</td>
                              <th style={this.thStyle2}>Teklif Türü</th>
                              <td>
                                {row.offerTypeName === null
                                  ? "-"
                                  : row.offerTypeName}
                              </td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Müşteri Telefon</th>
                              {/* <th className="colon">:</th> */}
                              <td>
                                {row.customerPhone === "" ? "-" : maskPhone}
                              </td>
                              <th style={this.thStyle2}>Müşteri E-mail</th>
                              <td>{row.customerEmail}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Kur</th>
                              <td style={this.tdStyle}>
                                {row.isExchangeRate &&
                                row.exchangeRate &&
                                row.exchangeRate !== 0
                                  ? row.exchangeRate + " ₺"
                                  : "-"}
                              </td>
                              <th style={this.thStyle2}>Toplam Tutar</th>
                              <td>
                                {row.discountTotal.toLocaleString("tr-TR", {
                                  minimumFractionDigits: 2,
                                }) +
                                  " " +
                                  (row.currencyType === 1
                                    ? "₺"
                                    : row.currencyType === 2
                                    ? "$"
                                    : row.currencyType === 3
                                    ? "€"
                                    : "-")}
                              </td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Firma Açıklama</th>
                              <td colSpan={3}>
                                {row.notDescription ? row.notDescription : "-"}
                              </td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Ekleyen Kullanıcı</th>
                              {/* <th className="colon">:</th> */}
                              <td colSpan={4}>{row.createdBy}</td>
                            </tr>
                          </tbody>
                        </Table>
                      );
                    },
                  },

                  {
                    selector: "status",
                    width: "150px",
                    padding: "0px",
                    center: true,
                    sortable: false,
                    cell: (row) => {
                      if (row.status === 1) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Beklemede"
                            style={{ backgroundColor: "red" }}
                          />
                        );
                      } else if (row.status === 2) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Onaylandı"
                            style={{ backgroundColor: "#29B237" }}
                          />
                        );
                      } else if (row.status === 3) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="İptal Edildi"
                            style={{
                              backgroundColor: "#FFC433",
                              color: "#333",
                            }}
                          />
                        );
                      } else if (row.status === 4) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Revize"
                            style={{ backgroundColor: "#FF6E33" }}
                          />
                        );
                      } else if (row.status === 5) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Fatura Kesildi"
                            style={{ backgroundColor: "#0679AF" }}
                          />
                        );
                      } else if (row.status === 6) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Arşiv"
                            style={{ backgroundColor: "#7C4811" }}
                          />
                        );
                      } else if (row.status === 7) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Haber Verilecek"
                            style={{ backgroundColor: "#6434CD" }}
                          />
                        );
                      } else if (row.status === 8) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Fiyatlandırılacak"
                            style={{ backgroundColor: "#cd34ad" }}
                          />
                        );
                      } else if (row.status === 9) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Ön Görüşme"
                            style={{ backgroundColor: "#34cdbb" }}
                          />
                        );
                      } else if (row.status === 10) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Bilgilendirme"
                            style={{
                              backgroundColor: "#ffeb00",
                              color: "#333",
                            }}
                          />
                        );
                      } else if (row.status === 11) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Fatura Bekleme"
                            style={{ backgroundColor: "#0000FF" }}
                          />
                        );
                      } else if (row.status === 12) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Cari Bekleme"
                            style={{ backgroundColor: "#cd853f" }}
                          />
                        );
                      } else if (row.status === 13) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Cari İşlendi"
                            style={{ backgroundColor: "#a0522d" }}
                          />
                        );
                      } else if (row.status === 14) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Garanti Kapsamında"
                            style={{ backgroundColor: "#333333" }}
                          />
                        );
                      } else if (row.status === 15) {
                        return (
                          <CgnBadge
                            color="secondary"
                            text="Sevk Edilecek"
                            style={{ backgroundColor: "#8b8970" }}
                          />
                        );
                      }
                    },
                  },
                  {
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    cell: (row, cell) => {
                      const showDetail = isAuthorized(row.authorizations, [
                        "isRead",
                      ]);
                      const showCopy = isAuthorized(row.authorizations, [
                        "isWrite",
                      ]);
                      const showSales = isAuthorized(row.authorizations, [
                        "isWrite",
                      ]);
                      const showPrint = isAuthorized(row.authorizations, [
                        "isRead",
                      ]);
                      const showEmail = isAuthorized(row.authorizations, [
                        "isRead",
                      ]);

                      const isAdmin =
                        localStorage.getItem("isAdmin") === "true";

                      const showUpdate =
                        !isAdmin && (row.status === 5 || row.status === 11)
                          ? false
                          : isAuthorized(row.authorizations, [
                              "isRead",
                              "isWrite",
                            ]);

                      const showDelete =
                        !isAdmin && (row.status === 5 || row.status === 11)
                          ? false
                          : isAuthorized(row.authorizations, ["isDelete"]);

                      const hasAnyPermission =
                        showUpdate ||
                        showDetail ||
                        showCopy ||
                        showSales ||
                        showPrint ||
                        showEmail ||
                        showDelete;

                      return (
                        <CgnButtonDropdown
                          label={"Yönet"}
                          className="mr-0"
                          color="primary"
                          disabled={!hasAnyPermission}
                          items={[
                            {
                              text: showUpdate ? CgnMessage.updateButton : "",
                              className: "dropDownBtn",
                              href: `/${this.state.pageUpdateLink}/${row.guid}`,
                            },
                            {
                              text: showDetail ? CgnMessage.detailButton : "",
                              className: "dropDownBtn",
                              href: `/${this.state.pageDetailLink}/${row.guid}`,
                            },
                            {
                              text: showSales
                                ? row.status === 2 ||
                                  row.status === 11 ||
                                  row.status === 12
                                  ? "Satışa Dönüştür"
                                  : ""
                                : "",
                              className: "dropDownBtn",
                              onClick: () =>
                                this.handleProductOutAlert(row.guid),
                            },
                            {
                              text: showCopy
                                ? row.status === 1
                                  ? "Kopyala"
                                  : ""
                                : "",
                              className: "dropDownBtn",
                              onClick: () => this.handleCopyOffer(row.guid),
                            },
                            {
                              text: showPrint ? "Teklif Yazdır" : "",
                              className: "dropDownBtn",
                              onClick: () => this.handlePdfPrint(row.guid),
                            },
                            {
                              text: showEmail
                                ? row.status === 1 && row.customerEmail !== ""
                                  ? "Teklif E-Mail Gönder"
                                  : ""
                                : "",
                              className: "dropDownBtn",
                              onClick: () => this.handlePdfSendMail(row.guid),
                            },
                            {
                              text: showDelete ? CgnMessage.deleteButton : "",
                              className: "dropDownBtn",
                              onClick: () => this.handleDelete(row.guid),
                            },
                          ]}
                        />
                      );
                    },
                  },
                ]}
                loading={this.state.isLoading}
              />
            </Card>
            <div className="d-block clearfix">
              <div className="float-right ListDownButton mr-2">
                Toplam Tutar (₺):{" "}
                {this.state.discountTotal.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                })}{" "}
                ₺
              </div>
              <div className="float-right ListDownButton mr-2">
                Toplam Tutar ($):{" "}
                {this.state.discountTotalDolar.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                })}{" "}
                $
              </div>
              <div className="float-right ListDownButton mr-2">
                Toplam Tutar (€):{" "}
                {this.state.discountTotalEuro.toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                })}{" "}
                €
              </div>
            </div>
          </Col>
        </Row>
      </>
    );
  }
}

export default OfferList;
